export const getEmbedUrl = (url, autoplay = true) => {
  if (!url) return null;
  const vimeo = url.match(/vimeo\.com\/(\d+)/);
  if (vimeo) {
    return `https://player.vimeo.com/video/${vimeo[1]}?${autoplay ? "autoplay=1&" : ""}title=0&byline=0&portrait=0`;
  }
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
  if (yt) {
    return `https://www.youtube.com/embed/${yt[1]}?${autoplay ? "autoplay=1&" : ""}rel=0`;
  }
  return null;
};
